import type { TMessageKey } from '@/src/lang/useTranslate'

export const extractKeyFromError = (error: Error): TMessageKey | undefined => {
  if (!error.cause) {
    return
  }

  const cause = error.cause as { key?: TMessageKey; errors?: { message?: TMessageKey }[] }

  if ('key' in cause) {
    return cause.key
  }

  return cause.errors?.[0]?.message
}
